import { OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { get } from 'lodash';
import * as moment from 'moment';
import { AuthService } from '@base/shared/services';
var HeaderBannerComponent = /** @class */ (function () {
    function HeaderBannerComponent(auth) {
        this.auth = auth;
        this.message = '';
        this.showClose = false;
        this.userType = 'submitter';
        this.bannerType = 'trial';
        this.account = {};
        this.closed = new Subject();
    }
    HeaderBannerComponent.prototype.ngOnInit = function () {
    };
    HeaderBannerComponent.prototype.closeAction = function () {
        this.closed.next(true);
    };
    Object.defineProperty(HeaderBannerComponent.prototype, "accountPermissions", {
        get: function () {
            return this.auth.user['permissions'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderBannerComponent.prototype, "remainingDays", {
        get: function () {
            var endDateLabel = this.bannerType === 'trial' ? 'trialEndDateTimeUtc' : 'lockoutDateTimeUtc';
            var endDate = get(this.account, endDateLabel);
            var daysLeft = get(this.account, 'daysLeftInTrial') || 0;
            if (this.bannerType === 'locked') {
                var today = moment();
                var diff = moment(endDate).diff(today, 'days');
                return diff;
            }
            // console.log(daysLeft)
            // if (!endDate)
            //   return;
            // const today = moment();
            // const diff = moment(endDate).diff(today, 'days');
            return daysLeft;
        },
        enumerable: true,
        configurable: true
    });
    return HeaderBannerComponent;
}());
export { HeaderBannerComponent };
